import script from "./DraftToolbar.vue?vue&type=script&setup=true&lang=js"
export * from "./DraftToolbar.vue?vue&type=script&setup=true&lang=js"

import "./DraftToolbar.vue?vue&type=style&index=0&id=55a33742&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55a33742"]])

export default __exports__